import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  loadRoleOptions,
  loadRoleOptionsSuccess,
} from './role-options.actions';
import { RoleOptionsService } from '../../shared/services/role-options.service';

@Injectable()
export class RoleOptionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(RoleOptionsService);

  public loadRoleOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRoleOptions),
      switchMap(() =>
        this.service
          .getRoleOptions()
          .pipe(
            map((options) => loadRoleOptionsSuccess({ roleOptions: options }))
          )
      )
    )
  );
}
